import { render, staticRenderFns } from "./setholidays.vue?vue&type=template&id=4753c572&scoped=true&"
import script from "./setholidays.vue?vue&type=script&lang=js&"
export * from "./setholidays.vue?vue&type=script&lang=js&"
import style0 from "./setholidays.vue?vue&type=style&index=0&id=4753c572&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4753c572",
  null
  
)

export default component.exports